import React, { Suspense } from 'react';
import { useRoutes } from 'react-router-dom';

// components
import Root from './Root';

// home
const Home = React.lazy(() => import('../pages/Home'));
const About = React.lazy(() => import('../pages/About'));
const Admin = React.lazy(() => import('../pages/Admin'));
const Tatacara = React.lazy(() => import('../pages/Tatacara'));
const Pengumuman = React.lazy(() => import('../pages/Pengumuman'));
const PengumumanAgg = React.lazy(() => import('../pages/Pengumuman/agg'));
const InfoDetail = React.lazy(() => import('../pages/InfoDetail'));
const Payment = React.lazy(() => import('../pages/Payment'));
const KurangBayar = React.lazy(() => import('../pages/Payment/KurangBayar'));
const AmbilSisa = React.lazy(() => import('../pages/AmbilSisa'));
const SendOTP = React.lazy(() => import('../pages/SendOtp'));
const TransferSukses = React.lazy(() => import('../pages/TransferSukses'));


const NotFound = React.lazy(() => import('../pages/Blog'));


const loading = () => <div className=""></div>;

type LoadComponentProps = {
    component: React.LazyExoticComponent<() => JSX.Element>;
};

const LoadComponent = ({ component: Component }: LoadComponentProps) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

const AllRoutes = () => {
    return useRoutes([
        {
            // root route
            path: '/',
            element: <Root />,
        },
        {
            // public routes
            path: '/',
            children: [
                 {
                    path: 'home',
                    element: <LoadComponent component={Home} />,
                },
                {
                    path: 'admin',
                    element: <LoadComponent component={Admin} />,
                },
                 {
                    path: 'about',
                    element: <LoadComponent component={About} />,
                },
                {
                    path: 'tatacara',
                    element: <LoadComponent component={Tatacara} />,
                },
                {
                    path: 'pengumuman',
                    element: <LoadComponent component={PengumumanAgg} />,
                },
                {
                    path: 'pengumuman/detail',
                    element: <LoadComponent component={Pengumuman} />,
                },
                {
                    path : 'detail/:id', element: <LoadComponent component={InfoDetail} />
                },
                {
                    path : 'payment/:secret/:id_perkara', element: <LoadComponent component={Payment} />
                },
                {
                    path : 'payment/:secret/:id_perkara/survey', element: <LoadComponent component={Payment} />
                },
                {
                    path : 'payment-kb/:secret/:id_perkara', element: <LoadComponent component={KurangBayar} />
                },
                {
                    path : 'ambil-sisa/t/:id', element: <LoadComponent component={AmbilSisa} />
                },
                {
                    path : 'ambil-sisa/t/:nomor/:secret/:requestid', element: <LoadComponent component={SendOTP} />
                },
                {
                    path : 'ambil-sisa/success/:id', element: <LoadComponent component={TransferSukses} />
                },
                {
                    path : '*', element: <LoadComponent component={NotFound} />
                }
                
            ],
        },
    ]);
};

export default AllRoutes;
